<div class="sl-wrap">

    <!-- HEADER -->
    <div class="sl-header">
        <div class="sl-header__info">
            <h2 class="sl-header__title">
                Comentarios de Redes Sociales
            </h2>
            <p class="sl-header__sub">
                Comentarios y respuestas de Instagram y Facebook
            </p>
        </div>
    </div>

    <!-- LOADING -->
    <div *ngIf="loading" class="sl-state sl-state--loading">
        <div class="sl-spinner"></div>
        <span>Cargando comentarios...</span>
    </div>

    <!-- EMPTY -->
    <div *ngIf="!loading && comments.length === 0" class="sl-state sl-state--empty">
        <div class="sl-state__icon">💬</div>
        <p class="sl-state__text">No existen comentarios.</p>
    </div>

    <!-- TABLE -->
    <div *ngIf="!loading && comments.length > 0" class="sl-card">

        <table class="sl-table">

            <thead>
                <tr class="sl-table__head-row">
                    <th class="col-msg">Comentario</th>
                    <th class="col-type">Tipo</th>
                    <th class="col-net">Red</th>
                    <th class="col-user">Usuario</th>
                    <th class="col-date">Fecha</th>
                    <th class="col-count">Respuestas</th>
                    <th class="col-actions">Acción</th>
                </tr>
            </thead>

            <tbody>

                <ng-container *ngFor="let comment of comments; let i = index">

                    <!-- ===================== -->
                    <!-- COMMENT ROW -->
                    <!-- ===================== -->
                    <tr class="comment-row">

                        <td class="col-msg" (click)="toggle(i)" style="cursor:pointer">
                            {{ comment.message }}
                        </td>

                        <td class="col-type">
                            <span class="type-badge" [ngClass]="comment.type?.toLowerCase()">
                                {{ comment.type === 'COMMENT' ? 'Comentario' : 'Mensaje' }}
                            </span>
                        </td>

                        <td class="col-net">
                            <span class="sl-net-pill"
                                [class]="'sl-net-pill--' + comment.network?.toLowerCase()">
                                {{ networkLabels[comment.network || ''] }}
                            </span>
                        </td>

                        <td class="col-user">
                            {{ comment.username || '-' }}
                        </td>

                        <td class="col-date">
                            {{ comment.createdAt | date:'dd/MM/yyyy HH:mm' }}
                        </td>

                        <td class="col-count">
                            {{ comment.replies?.length || 0 }}
                        </td>

                        <!-- ACTION -->
                        <td class="col-actions">

                            <button class="sl-icon-btn btn-reply"
                                    (click)="openReply(comment, $event)">
                                💬
                            </button>
                            <button class="sl-icon-btn btn-delete"
                                        (click)="deleteComment(comment, $event)">
                                    🗑
                                </button>
                        </td>

                    </tr>

                    <!-- ===================== -->
                    <!-- FORM RESPUESTA (COMMENT LEVEL) -->
                    <!-- ===================== -->
                    <tr *ngIf="replyTarget?.externalId === comment.externalId">

                        <td colspan="7" class="reply-actions">

                            <div class="reply-form">

                                <textarea
                                    [(ngModel)]="replyMessage"
                                    placeholder="Escribe tu respuesta..."
                                    rows="2">
                                </textarea>

                                <div class="reply-form-actions">

                                    <button class="btn-send"
                                            (click)="sendReply()">
                                        Enviar
                                    </button>

                                    <button class="btn-cancel"
                                            (click)="replyTarget = null">
                                        Cancelar
                                    </button>

                                </div>

                            </div>

                        </td>

                    </tr>

                    <!-- ===================== -->
                    <!-- REPLIES -->
                    <!-- ===================== -->
                    <tr *ngIf="expandedIndex === i">

                        <td colspan="7" class="reply-box">

                            <div *ngIf="!comment.replies?.length" class="empty-replies">
                                Sin respuestas
                            </div>

                            <!-- REPLY LIST -->
                            <div *ngFor="let reply of comment.replies" class="reply-item">

                                <div class="reply-header">
                                    <strong>{{ reply.username }}</strong>
                                    <span>{{ reply.createdAt | date:'dd/MM/yyyy HH:mm' }}</span>
                                </div>

                                <div class="reply-message">
                                    {{ reply.message }}</div>

                                <!-- ===================== -->
                                <!-- FORM RESPUESTA (REPLY LEVEL) -->
                                <!-- ===================== -->
                                <div *ngIf="replyTarget?.externalId === reply.externalId"
                                     class="reply-form inline">

                                    <textarea
                                        [(ngModel)]="replyMessage"
                                        placeholder="Responder a este mensaje"
                                        rows="2">
                                    </textarea>

                                    <div class="reply-form-actions">

                                        <button class="btn-send"
                                                (click)="sendReply()">
                                            Enviar
                                        </button>

                                        <button class="btn-cancel"
                                                (click)="replyTarget = null">
                                            Cancelar
                                        </button>

                                    </div>

                                </div>

                                <!-- BUTTON -->
                                <div class="reply-actions-inline">

                                    <button class="btn-reply"
                                            (click)="openReplyToChild(reply, $event)">
                                        💬
                                    </button>

                                    <button class="btn-delete"
                                            (click)="deleteComment(reply, $event)">
                                        🗑
                                    </button>

                                </div>

                            </div>

                        </td>

                    </tr>

                </ng-container>

            </tbody>

        </table>

    </div>

</div>
<!-- DELETE DIALOG -->
<div class="dialog-backdrop" *ngIf="showDeleteDialog">

    <div class="dialog">

        <div class="dialog-icon">⚠️</div>

        <h3>Eliminar comentario</h3>

        <p>¿Seguro que deseas eliminar este comentario?</p>

        <div class="dialog-actions">

            <button class="btn-cancel"
                    (click)="cancelDelete()">
                Cancelar
            </button>

            <button class="btn-danger"
                    (click)="confirmDelete()">
                Eliminar
            </button>

        </div>

    </div>

</div>